module.exports = __webpack_public_path__ + "static/ffde8b92.top.png";